import { Blockchain } from './common'

export const BaseCurrencies = {
  [Blockchain.Ethereum]: 'ETH',
  [Blockchain.Binance]: 'BNB',
  [Blockchain.Polygon]: 'MATIC',
  [Blockchain.Fantom]: 'FTM',
  [Blockchain.Tron]: 'TRX',
  [Blockchain.Arbitrum]: 'ETH',
  [Blockchain.Optimism]: 'ETH',
  [Blockchain.Base]: 'ETH',
}
